<!-- 采购订单 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">订单号:</div>
            <el-input
                style="width: 250px"
                class="search-item"
                size="small"
                v-model.trim="searchData.OrderCode"
                v-filter-special-char="searchData.OrderCode"
                placeholder="请输入订单号"
            ></el-input>
            <div class="search-name">状态:</div>
            <el-select v-model="searchData.State" placeholder="请选择" size="small" class="search-item">
                <el-option v-for="item in OrderCodeList" :key="item.value" :label="item.value" :value="item.key"></el-option>
            </el-select>
            <div class="search-name">时间:</div>
            <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
            <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
            <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
        </div>
        <div class="order-list">
            <div class="order-item" :key="item.Id" v-for="item in tableData">
                <div class="div-table-row">
                    <div class="div-table-cell order-num" style="width: 100%; line-height: 46px">
                        <div>
                            <span class="order-time">{{ item.CreateTime }}</span>
                            <span>订单号：{{ item.OrderCode }}</span>
                        </div>
                        <div v-if="item.ChildOrders">您订单中的商品在不同的库房或属于不同商家，故拆分为以下订单分开配送</div>
                    </div>
                </div>
                <!-- 拆分订单 -->
                <div v-if="item.ChildOrders">
                    <div class="div-table-row">
                        <div class="div-table-cell order-num-children" style="width: 100%">
                            <div>
                                <span class="order-time">收货人：{{ item.Consignee }}</span>
                                <span class="order-time">订单金额：￥{{ item.OrderAmount }}</span>
                                <span class="order-time">支付方式：{{ item.SettlementMethod }}</span>
                                <span class="order-time">订单状态：已拆分</span>
                            </div>
                            <div></div>
                        </div>
                    </div>
                    <template v-for="(i, index) in item.ChildOrders">
                        <div :key="index" class="div-table-row">
                            <div class="div-table-cell" style="width: 100%; padding-left: 20px">
                                <span class="order-time">{{ i.CreateTime }}</span>
                                <span>订单号：{{ i.ChildOrderCode }}</span>
                            </div>
                        </div>
                        <div :key="index" class="div-table-row">
                            <div class="div-table-cell" style="width: 40%">
                                <div :key="index2" class="order-msg" v-for="(goods, index2) in i.GoodsList">
                                    <img :src="downloadUrl + goods.MainImg" alt class="shop-cover" :onerror="defaultImg" />
                                    <div class="goods-name" :title="goods.GoodsName">{{ goods.GoodsName }}</div>
                                    <div class="shop-num">x{{ goods.Count }}</div>
                                    <div class="shouh page-link">
                                        <span @click="gotoApplyDetails(i.Id, i.OrderCode, goods.GoodsId)" v-if="item.State == 5 && permission.applyAfter">{{
                                            permission.applyAfter
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="div-table-cell order-man">{{ i.Consignee }}</div>
                            <div class="div-table-cell shop-price">
                                <p class="money-value">总金额：￥{{ i.OrderAmount }}</p>
                                <p>{{ i.SettlementMethod }}</p>
                            </div>
                            <div class="div-table-cell shop-staus">
                                <p class="money-value">{{ item.StateName }}</p>
                                <p @click="gotoDetail(i.Id)" class="gotoDetail page-link" v-if="permission.see">{{ permission.see }}</p>
                            </div>
                            <div class="div-table-cell shop-staus">
                                <template v-if="item.State > 4 && permission.edit">
                                    <p class="money-value page-link" @click="gotoInvoice(item.Id)" v-if="item.IsInvoiced && permission.seeInvoice">{{ permission.seeInvoice }}</p>
                                    <p class="money-value page-link" @click="showInvoice(item.Id)" v-else-if="!item.IsInvoiced && permission.openInvoiced">
                                        {{ permission.openInvoiced }}
                                    </p>
                                    <!--<p><el-button size="small" @click="buyNow(i.Id)">再次购买</el-button></p>-->
                                </template>
                                <p class="money-value page-link" @click="gotoEdit(item.Id)" v-if="permission.createAsk">{{ permission.createAsk }}</p>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- 不拆分 -->
                <div v-else>
                    <template>
                        <div class="div-table-row">
                            <div class="div-table-cell" style="width: 40%">
                                <div :key="index" class="order-msg" v-for="(goods, index) in item.GoodsList">
                                    <img :src="downloadUrl + goods.MainImg" alt class="shop-cover" :onerror="defaultImg" />
                                    <div class="goods-name" :title="goods.GoodsName">{{ goods.GoodsName }}</div>
                                    <div class="shop-num">x{{ goods.Count }}</div>
                                    <div class="shouh page-link">
                                        <span @click="gotoApplyDetails(item.Id, item.OrderCode, goods.GoodsId)" v-if="item.State == 5 && permission.applyAfter">{{
                                            permission.applyAfter
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="div-table-cell order-man">{{ item.Consignee }}</div>
                            <div class="div-table-cell shop-price">
                                <p class="money-value">总金额：￥{{ item.OrderAmount }}</p>
                                <p>{{ item.SettlementMethod }}</p>
                            </div>
                            <div class="div-table-cell shop-staus">
                                <p class="money-value">{{ item.StateName }}</p>
                                <p @click="gotoDetail(item.Id)" class="page-link" v-if="permission.see">{{ permission.see }}</p>
                            </div>
                            <div class="div-table-cell shop-staus">
                                <template v-if="item.State > 4 && permission.edit">
                                    <p class="money-value page-link" @click="gotoInvoice(item.Id)" v-if="item.IsInvoiced && permission.seeInvoice">{{ permission.seeInvoice }}</p>
                                    <p class="money-value page-link" @click="showInvoice(item.Id)" v-else-if="!item.IsInvoiced && permission.openInvoiced">
                                        {{ permission.openInvoiced }}
                                    </p>
                                </template>
                                <p class="money-value page-link" @click="gotoEdit(item.IBId)" v-if="permission.createAsk">{{ permission.createAsk }}</p>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="no-data" v-if="tableDataLength == 0">暂无数据</div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" width="800px" title="开发票" :visible.sync="invoiceShow" :before-close="handleClose" append-to-body>
            <invoice ref="invoice" :orderId="invoiceOrderId" @closeInvoice="closeInvoice"></invoice>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import invoice from '@/components/common/invoice';
import mixin from '@/mixins/mixin';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        invoice,
        timePicker,
        breadcrumb
    },
    data() {
        return {
            timeVisible: false,
            permission: {},
            invoiceOrderId: '',
            invoiceShow: false,
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            searchData: {
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                OrderCode: '',
                State: null,
                StartTime: null,
                EndTime: null,
                limit: 15,
                page: 1,
                key: null
            },
            OrderCodeList: [],
            tableData: [],
            tableDataLength: 0
        };
    },
    mounted() {
        this.getTableData();
        this.getOrderCodeList();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('PurchaseOrder');
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        //
        gotoEdit(id) {
            this.$router.push(`./rfqEdit?type=4&id=${id}`);
        },
        handleClose() {
            this.$refs.invoice.clearData();
            this.invoiceShow = false;
        },
        // 重置搜索条件
        resetSearch() {
            this.searchData = {
                EntpId: this.searchData.EntpId,
                OrderCode: '',
                State: null,
                StartTime: null,
                EndTime: null,
                limit: this.commonPageSize,
                page: 1,
                key: null
            };
        },
        // 显示开发票页面
        showInvoice(id) {
            this.invoiceOrderId = id;
            this.invoiceShow = true;
        },
        //
        gotoApplyDetails(OrderId, orderCode, GoodId) {
            this.$util
                .axiosGet({
                    url: `/api/CustomerService/GetEntpOrderAfterSaleInfo`,
                    data: {
                        OrderId: OrderId,
                        GoodId: GoodId ? GoodId : 'GoodId'
                    }
                })
                .then(res => {
                    let data = res.data[0];
                    if (data && data.Detail[0]) {
                        this.$router.push(`../service/afterApplyDetails?OrderId=${OrderId}&OrderCode=${orderCode}&GoodId=${GoodId ? GoodId : ''}`);
                    } else {
                        this.$util.warningMsg('当前订单无法申请售后');
                    }
                })
                .catch(() => {});
        },
        // 跳转发票详情
        gotoInvoice(OrderId) {
            this.$router.push('/goods/invoiceDetails?OrderId=' + OrderId);
        },
        // 获取企业订单状态
        getOrderCodeList() {
            this.$util
                .axiosGet({
                    url: '/api/PurchaseManager/GetEntpOrderStates',
                    data: {}
                })
                .then(res => {
                    let data = res.data;
                    this.OrderCodeList = data;
                })
                .catch(() => {});
        },
        closeInvoice() {
            this.invoiceShow = false;
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/PurchaseManager/GetEntpOrderList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        // 跳转到详情页
        gotoDetail(id) {
            this.$router.push(`/business/purchaseManage/orderDetails?OrderId=${id}`);
        },
        buyNow(id) {
            this.$util.buyAgain(id);
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.shouh {
    width: 4em;
}
.goods-name {
    width: 150px;
}
.order-item {
    margin-bottom: 20px;
}
.page-link {
    cursor: pointer;
    color: @theme;
}
.div-table-cell {
    line-height: 36px;
}
.order-num {
    background: @border2Color;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
}
.order-num-children {
    position: relative;
    background: @border4Color;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
}
.order-time {
    margin-right: 60px;
}
.order-msg {
    display: flex;
    padding: 20px;
    justify-content: space-between;
    align-items: center;
}
.shop-cover {
    width: 80px;
    height: 80px;
}
.order-man {
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.shop-price {
    width: 15%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: @font3Color;
    .money-value {
        border-bottom: 1px solid @border3Color;
    }
}
.shop-staus {
    width: 15%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: @font3Color;
}
.gotoDetail {
    cursor: pointer;
}
.no-data {
    font-size: @font-lg;
    color: @font4Color;
    height: 300px;
    line-height: 300px;
    text-align: center;
}
</style>
